export function storageKey(key: string, appGroup?: string) {
  return `${appGroup ? `${appGroup}:` : ''}${key}`
}
